import styled, { css } from 'styled-components';

export const Image = styled.img<{
  width?: number;
  height?: number;
  borderRadius?: number | undefined;
  objectFit?: 'none' | 'fill' | 'cover';
}>`
  ${({ width, height, objectFit, borderRadius }) => css`
    width: ${width}px;
    height: ${height}px;
    object-fit: ${objectFit ?? 'fill'};
    border-radius: ${borderRadius}%;
  `}
`;
